'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import parse, { domToReact, type HTMLReactParserOptions, Element } from 'html-react-parser';

import { cn } from '@eliadmin/core/src/utils/style-utils';

interface HeadingProps {
  title: string;
  subtitle?: string;
  className?: {
    title?: string;
    subtitle?: string;
    container?: string;
  };
  tag?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  /** Heading semantics independent from the existing visual style. */
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';
}

export function Heading({ title, subtitle, className, tag = 'h2', as }: HeadingProps) {
  const Tag = as ?? tag;

  const parsedTitle = parse(title, {
    replace: domNode => {
      if (domNode instanceof Element && domNode.name === 'span') {
        return (
          <span {...domNode.attribs}>
            {domToReact(domNode.children as any)}
            <Image
              src="/images/hero-line.svg"
              alt=""
              height={0}
              width={0}
              className="absolute bottom-0 left-0 z-[-1] h-auto w-full object-contain object-center"
            />
          </span>
        );
      }
    },
  } as HTMLReactParserOptions);

  return (
    <div className={cn('flex flex-col gap-4', 'ea-heading__container', className?.container)}>
      {subtitle && (
        <p
          data-ea-visual-tag="h6"
          className={cn(
            'font-normal uppercase -tracking-tighter text-secondary',
            'ea-heading__subtitle',
            className?.subtitle,
          )}
        >
          {subtitle}
        </p>
      )}
      <Tag
        data-ea-visual-tag={tag}
        className={cn(
          'relative z-[5] font-semibold tracking-tight text-black',
          'ea-heading__title',
          tag,
          className?.title,
        )}
      >
        {parsedTitle}
      </Tag>
    </div>
  );
}
